import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { Link } from "react-router-dom";

interface Props {
  name: string;
  email: string;
  picture: string;
  role: "member" | "admin";
  onSignOut: () => void;
}

export function UserMenu({ name, email, picture, role, onSignOut }: Props): JSX.Element {
  const firstName = name.split(" ")[0] || email;
  return (
    <DropdownMenu.Root>
      <DropdownMenu.Trigger asChild>
        <button
          type="button"
          className="group inline-flex items-center gap-2 rounded-full bg-muted hover:bg-border px-2 py-1 focus:outline-none focus:ring-2 focus:ring-primary/40"
        >
          {picture ? (
            <img src={picture} alt="" className="h-7 w-7 rounded-full" referrerPolicy="no-referrer" />
          ) : (
            <span className="inline-flex h-7 w-7 items-center justify-center rounded-full bg-primary text-primary-foreground text-xs font-semibold">
              {firstName.slice(0, 2).toUpperCase()}
            </span>
          )}
          <span className="hidden sm:inline text-sm">{firstName}</span>
          <svg
            data-chevron
            aria-hidden="true"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-5 w-5 text-muted-foreground transition-transform duration-200 group-data-[state=open]:rotate-180"
          >
            <path d="M6 9l6 6 6-6" />
          </svg>
        </button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Portal>
        <DropdownMenu.Content
          align="end"
          sideOffset={6}
          className="z-50 min-w-[240px] rounded-card border border-border bg-card p-1 shadow-lg"
        >
          <div className="px-3 py-2">
            <div className="text-sm font-medium text-foreground">{name}</div>
            <div className="text-xs text-muted-foreground truncate">{email}</div>
            <div className="mt-1">
              <span className="inline-block rounded bg-muted px-2 py-0.5 text-xs uppercase tracking-wider text-primary">
                {role}
              </span>
            </div>
          </div>
          <DropdownMenu.Separator className="my-1 h-px bg-border-subtle" />
          {role === "admin" && (
            <DropdownMenu.Item asChild>
              <Link to="/admin/operations-guide" className="block rounded px-3 py-2 text-sm hover:bg-muted focus:bg-muted outline-none">
                Operations guide
              </Link>
            </DropdownMenu.Item>
          )}
          <DropdownMenu.Item asChild>
            <Link to="/profile" className="block rounded px-3 py-2 text-sm hover:bg-muted focus:bg-muted outline-none">
              Profile
            </Link>
          </DropdownMenu.Item>
          <DropdownMenu.Separator className="my-1 h-px bg-border-subtle" />
          <DropdownMenu.Item
            onSelect={onSignOut}
            className="block rounded px-3 py-2 text-sm text-destructive hover:bg-destructive/10 focus:bg-destructive/10 outline-none cursor-pointer"
          >
            Sign out
          </DropdownMenu.Item>
        </DropdownMenu.Content>
      </DropdownMenu.Portal>
    </DropdownMenu.Root>
  );
}
